/**
 * Кастомная иконка «Замок» — закрытый замок (filled)
 *
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function LockIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M11.9857 2C14.8739 2 17.1978 4.41479 17.1978 7.39601V8.92935C18.8189 9.46696 20 11.0261 20 12.8884V17.8253C20 20.1308 18.2011 22 15.9833 22H8.01769C5.79892 22 4 20.1308 4 17.8253V12.8884C4 11.0261 5.18207 9.46696 6.80215 8.92935V7.39601C6.81172 4.41479 9.13568 2 11.9857 2ZM11.9952 13.3843C11.5362 13.3843 11.1632 13.7718 11.1632 14.2488V16.4549C11.1632 16.9419 11.5362 17.3294 11.9952 17.3294C12.4638 17.3294 12.8368 16.9419 12.8368 16.4549V14.2488C12.8368 13.7718 12.4638 13.3843 11.9952 13.3843ZM12.0048 3.73904C10.0634 3.73904 8.48536 5.36878 8.47579 7.37613V8.7137H15.5242V7.39601C15.5242 5.37871 13.9462 3.73904 12.0048 3.73904Z"
        fill="currentColor"
      />
    </svg>
  );
}